import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import MinipayLogin from 'src/content/minipay/Login/Cover';

// Cópia de src/components/Authenticated — só troca a tela de login exibida
// quando não autenticado, pra nunca mostrar o login (escuro) do app principal
// dentro do minipay.
const MinipayAuthenticated = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const fullPath = location.pathname + location.search;
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!auth.isAuthenticated) {
    if (fullPath !== requestedLocation) {
      setRequestedLocation(fullPath);
    }
    return <MinipayLogin />;
  }

  if (requestedLocation && fullPath !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

MinipayAuthenticated.propTypes = {
  children: PropTypes.node
};

export default MinipayAuthenticated;
